import gql from "graphql-tag";

const GetPorts = gql`
  query {
    ports {
      id
      name
      description
    }

    DangerousGoodsInfo {
      id
      un_number
      proper_shipping_name
      imo_class
      packing_group
    }
  }
`;

export default GetPorts;
